<template>
  <div class="iq-search-wrapper">
      <!-- File Upload Button -->
      <!-- <v-img
        alt="Attach"
        class="iq-icon"
        :src="require('@components/assets/file-icons.svg')"
        @click="triggerFileUpload"
      ></v-img> -->

      <!-- Hidden file input -->
      <!-- <input
        type="file"
        ref="fileInput"
        @change="handleFileSelect"
        style="display: none;"
      /> -->

      <!-- Text input showing file name or query -->
      <input
        type="text"
        v-model="searchQuery"
        placeholder="Ask IQ AI"
        aria-label="Ask IQ AI"
        @keyup.enter="handleSend"
        class="iq-search-input"
      />

      <!-- Send/Stop Button -->
      <button
        type="button"
        class="iq-send-button"
        :aria-label="isGenerating ? 'Stop generating' : 'Send'"
        @click="handleSend"
      >
        <v-icon v-if="!isGenerating">mdi-arrow-up</v-icon>
        <v-icon v-else>mdi-stop</v-icon>
      </button>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  isGenerating: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['submit', 'stop']);

const searchQuery = ref('');
const selectedFile = ref(null);
const fileInput = ref(null);

const triggerFileUpload = () => {
  fileInput.value.click();
};

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    selectedFile.value = file;
    searchQuery.value = file.name;
  }
};

const handleSend = () => {
  if (props.isGenerating) {
    // If generating, stop the generation
    emit('stop');
  } else {
    // If not generating, submit the query
    if (selectedFile.value || searchQuery.value.trim()) {
      emit('submit', selectedFile.value || searchQuery.value);
      // Clear the input after sending
      searchQuery.value = '';
      selectedFile.value = null;
      if (fileInput.value) {
        fileInput.value.value = '';
      }
    }
  }
};
</script>

<style scoped>
.iq-search-wrapper {
  display: flex;
  align-items: center;
  background-color: #f2f4f7;
  border: 1px solid transparent;
  border-radius: 9999px;
  padding: 4px 8px 4px 16px;
  width: 100%;
  max-width: 600px;
  transition: border-color 150ms ease, background-color 150ms ease;
}

.iq-search-wrapper:focus-within {
  background-color: #ffffff;
  border-color: #d0d5dd;
}

.iq-icon {
  position: absolute;
}

.iq-search-input {
  background: transparent;
  border: none;
  outline: none;
  color: #101828;
  flex: 1;
  padding: 8px 12px;
  font-family: Helvetica;
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  margin-left: 16px;
}

.iq-search-input::placeholder {
  color: #98a2b3;
  opacity: 1;
}

.iq-send-button {
  background-color: #ed2738;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.iq-send-button:hover {
  background-color: #d92d20;
}

.iq-send-button:focus-visible {
  outline: 2px solid #ed2738;
  outline-offset: 2px;
}

.iq-send-button .v-icon {
  color: #ffffff;
  font-size: 20px;
}
</style>


